import { customRef } from 'vue'

import { COOKIES_MAX_AGE, getCookie, setCookie } from '@/utils/cookie'

export interface CookieOptions {
  /** Значение, когда cookie ещё нет */
  default?: string
  maxAge?: number
}

/**
 * Реактивная ссылка на cookie — аналог `useCookie` из Nuxt, чтобы
 * состояние (пользователь, регион, ресторан, координаты) переносилось
 * из веб-версии один в один. Запись сразу уходит в document.cookie.
 */
export function useCookie(name: string, options: CookieOptions = {}) {
  const { default: fallback = '', maxAge = COOKIES_MAX_AGE } = options

  return customRef<string>((track, trigger) => {
    let value = getCookie(name) || fallback

    return {
      get() {
        track()
        return value
      },
      set(next) {
        value = next
        setCookie(name, next, maxAge)
        trigger()
      },
    }
  })
}
